import React, {Component, PropTypes} from 'react'
import ToolTip from '../ToolTip'
import ClientSideCacheController from '../ClientSideCacheController';
import Cannonicalize from '../Cannonicalize';
import Analytics from '../Analytics'

const dayArr = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const monthArr = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
  'September', 'October', 'November', 'December'];

class SchoolClosings extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;
    this.debug= props.debug;
    this.state = {
      closings: [],
      searchString: '',
      showSchools: true,
      showChurches: true,
      showOther: true
    }

    let d = new Date();
    this.date = `
      ${dayArr[d.getUTCDay()]},
      ${monthArr[d.getMonth()]} ${d.getDate()},
      ${d.getFullYear()}
    `;
  }


  componentWillMount() {

    try {

      this.setState( {closings: Cannonicalize.schoolClosing(this.props.FRN_rawResponses[0].data)})
    } catch (e) {
      console.warn('Illegitimate FRN_rawResponses in School Closings', e)
    }
    if (typeof window !== 'object')
      return
    ClientSideCacheController.setAffiliate(this.props.affiliate)
    ClientSideCacheController.get('schoolClosing',{debug: this.debug}).then((res) => {
      this.setState({closings: res})
    })

  }



  render() { // REQUIRED
    try{
      return (<div className='gnm-school-closings'>
        <div className="gnm-school-closings table-responsive">
          <div className="row">
            <div className="col-xs-12 col-sm-6 col-md-7 col-lg-8">
              <h2 className="h4">School Closings</h2>
              <h3 className="h5">{this.date}</h3>
            </div>
            <div className="hidden-xs col-sm-6 col-md-5 col-lg-4 clearfix">
              <ToolTip title='Notify Us of Closings' width={320}>
                <p>
                  <span>To report a school or church closing please visit </span>
                  <a href="http://www.NewsOn6.com/CloseMySchool" target="_blank">NewsOn6.com/CloseMySchool</a>
                  <span>, at the log-in prompt, enter the School ID number and password you received in the mail.</span>
                </p>
                <p>
                  <span>If you do not have a username and password, or have questions send an e-mail to </span>
                  <a href="mailto:closemyschool@newson6.net?subject=School Closings System Questions">closemyschool@newson6.net</a>.
                  </p>
              </ToolTip>
              <a href="http://www.NewsOn6.com/CloseMySchool" role="button" className="btn btn-danger" target="_blank">
                <i className="fa fa-user-plus" aria-hidden="true"></i>Report A Closing
              </a>
            </div>
            <div className="col-xs-12 col-sm-7 col-lg-8 clearfix">
              <div className="input-group">
                <input type="text" className="form-control" placeholder="Type School Name" onChange={(e)=>{
                    this.setState({searchString: e.target.value})
                  }} />
                <span className="input-group-addon">
                  <i className="glyphicon glyphicon-search"></i>
                </span>
              </div>
            </div>
            <div className="col-xs-12 col-sm-5 col-lg-4">
              <input className='checkbox' type="checkbox" checked={this.state.showSchools} onChange={(e)=>{
                  this.setState({showSchools: !this.state.showSchools})
                }}/>
              <label >School</label>
              <input  className='checkbox' type="checkbox" checked={this.state.showChurches} onChange={(e)=>{
                    this.setState({showChurches: !this.state.showChurches})
                }}/>
              <label >Church</label>
              <input className='checkbox'   type="checkbox" checked={this.state.showOther} onChange={(e)=>{
                    this.setState({showOther: !this.state.showOther})
                }}/>
              <label >Other</label>
            </div>
            <div className="col-xs-12">
              <table className="table table-hover table-striped table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th>Name</th>
                    <th className='hidden-xs'>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.closings
                    .filter((c)=>{
                      if(!this.state.showChurches && c.type === 2)
                        return false
                      if(!this.state.showSchools && c.type === 1)
                        return false
                      if(!this.state.showOther && c.type === 3)
                        return false
                      if(!this.state.searchString)
                        return true
                      let pattern = new RegExp(this.state.searchString,'i')
                      if(pattern.exec(c.name))
                        return true
                      return false
                    })
                    .map(function(c,i,a){
                      return(
                        <tr key ={i}>
                          <td>{c.name.replace(/<\/?[^>]+(>|$)/g, "").replace(/&(.*?);/g, ' ')}</td>
                          <td className="closings-status-xs">{c.status}</td>
                        </tr>
                      )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>)

    } catch (e) {
      e.message += ' in School Closings, causing render failure'
      Analytics.reportError(e)
      return null
    }
  }
}

export default SchoolClosings



// WEBPACK FOOTER //
// ./app/components/custom/ssr/SchoolClosings/index.js